import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

async function fetchCityWeather (cityId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), '/weather')
    const response = await axios.get(url)

    return response.data
}

export default { fetchCityWeather }


// WEBPACK FOOTER //
// ./src/services/weather.js